// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sy-0";